import * as m from "mithril";
import { MessageProvider } from "../../../context/AppMessages";
import { DropOffOrderDTO, PickUpOrderDTO, TripResultDTO } from "../../../apiclient/ApiDtos";
import { getIntlStringValue } from "../../../helpers/StringHelpers";
import { WayPointItemComponent } from "./WayPointItemComponent";
import './PickUpDropOffSelectionPage.scss';
interface Attrs {
    messageProvider: MessageProvider,
    totalNumberOfSeats: number,
    trip: TripResultDTO,
    pickUpOrder?: PickUpOrderDTO,
    dropOffOrder?: DropOffOrderDTO,
}


export function PickupDropOffDetailsComponent(): m.Component<Attrs> {
    return {
        view(vnode) {
            let { trip, pickUpOrder, dropOffOrder, messageProvider } = vnode.attrs;
            let currLang = vnode.attrs.messageProvider.getCurrentLang();

            return m("div.rounded",
                m("div.itinerary.itinerary-md-two-columns.mt-2",
                    m("div.waypoint-figure.text-body-sm_", [
                        m("div.edge-top"),
                        m("div.node-active"),
                        m("div.edge-bot.edge-active-dotted"),
                    ]),


                    m("div.waypoint-name.text-body-sm_",
                        m("div",
                            getIntlStringValue(trip.departure.location.name, currLang),
                            m("span.text-muted ml-1 small",
                                "(",
                                vnode.attrs.totalNumberOfSeats > 1 ?
                                    messageProvider.get("way_point_selection.pickup_locations_and_addresses") :
                                    messageProvider.get("way_point_selection.pickup_location_and_address"),
                                ")"
                            )
                        ),

                    ),


                    m("div.waypoint-figure.text-body-sm_", [
                        m("div.edge-top.edge-active-dotted"),
                        m("div.edge-mid.edge-active-dotted"),
                        m("div.edge-bot.edge-active-dotted"),
                    ]),


                    m(
                        "div.waypoint-details.text-body-sm_",
                        m("div.mb-4",

                            pickUpOrder &&
                            pickUpOrder.lineItems.map(pickuplineitem => {
                                return m("div.mt-1",
                                    m(WayPointItemComponent, {
                                        hideNumberOfPerson: (vnode.attrs.totalNumberOfSeats == 1),
                                        messageProvider: vnode.attrs.messageProvider,
                                        wayPoint: pickuplineitem
                                    })
                                )
                            })
                        ),
                    ),


                    //Drop-Off

                    m("div.waypoint-figure.text-body-sm_", [
                        m("div.edge-top.edge-active-dotted"),
                        m("div.node-active"),
                        m("div.edge-bot"),
                    ]),

                    m("div.waypoint-details.text-body-sm_",
                        getIntlStringValue(trip.arrival.location.name, currLang),
                        m("span.text-muted ml-1 small",
                            "(",
                            vnode.attrs.totalNumberOfSeats > 1 ?
                                messageProvider.get("way_point_selection.dropoff_locations_and_addresses") :
                                messageProvider.get("way_point_selection.dropoff_location_and_address"),
                            ")"
                        )
                    ),


                    m("div.waypoint-figure.text-body-sm_"),

                    m("div.waypoint-details.text-body-sm_",
                        m("div.mb-4",
                            dropOffOrder &&
                            dropOffOrder.lineItems.map(dropOffLineItem => {
                                return m("div.mt-1",
                                    m(WayPointItemComponent, {
                                        hideNumberOfPerson: (vnode.attrs.totalNumberOfSeats == 1),
                                        messageProvider: vnode.attrs.messageProvider,
                                        wayPoint: dropOffLineItem
                                    })
                                )
                            })
                        ),
                    ),
                ))
        }

    }
}